<header class="relative px-4 pb-4 pt-2">
  <h1 class="text-2xl font-semibold text-greyscale-900">Statistics</h1>
  <p class="text-sm text-greyscale-600">
    Browse and export platform statistics
  </p>
</header>
<main class="p-4">
  <section class="mb-4 rounded-lg border border-gray-200 bg-white p-4">
    <h2 class="mb-4 text-lg text-primary-500">downloads</h2>
    <app-download-trips-list />
  </section>
</main>
